import { useEffect, useRef, useState } from "react";
import { CiMenuKebab } from "react-icons/ci";
import { Collapse, ListGroup } from "react-bootstrap";
import { studyEDCLupReportingServices } from "../../APIServices/studyEDCLupReportingServices";
import UploadFileDataLibrary from "./LupReportManagement/UploadFileDataLibrary";
import UseToggle from "../../Hooks/UseToggle";
import UpdateFileDataLibrary from "./LupReportManagement/UpdateFileDataLibrary";
import DuplicateFileDataLibrary from "./LupReportManagement/DuplicateFileDataLibrary";
import Swal from "sweetalert2";
import DeletedLupDataset from "./LupReportManagement/DeletedLupDataset";
import FileDataProperties from "./LupReportManagement/FileDataProperties";

const LupReportingStudySidebar = ({ studyId, handleAddNewTab, checkActiveTab, checkActiveDynamicTabData, collapseSidebar, studyLabel }) => {
  const [openReporting, setOpenReporting] = useState(false);
  const [openLUPGenerateReport, setOpenLUPGenerateReport] = useState(false);
  const [openLUPProgram, setOpenLUPProgram] = useState(false);
  const [openLUPLogs, setOpenLUPLogs] = useState(false);
  const [openLUPOutput, setOpenLUPOutput] = useState(false);
  const [openLUPReport, setOpenLUPReport] = useState(false);
  const [openLUPDataLibrary, setOpenLUPDataLibrary] = useState(false);
  const [openLUPEDCWIDEData, setOpenLUPEDCWIDEData] = useState(false);
  const [openLUPEDCTRANSData, setOpenLUPEDCTRANSData] = useState(false);
  const [openLUPAnalysisData, setOpenLUPAnalysisData] = useState(false);
  const [openLUPStandardData, setOpenLUPStandardData] = useState(false);
  const [openLUPRawData, setOpenLUPRawData] = useState(false);
  const [openLUPTempData, setOpenLUPTempData] = useState(false);
  const [openLupOption, setOpenLupOption] = useState("");
  const toggles = UseToggle()
  const [LUPReportMetadata, setLUPReportMetadata] = useState([]);
  const [LUPReportEDCWIDEDataset, setLUPReportEDCWIDEDataset] = useState([]);
  const [LUPReportEDCTRANSDataset, setLUPReportEDCTRANSDataset] = useState([]);
  const [LUPReportAnalysisDataset, setLUPReportAnalysisDataset] = useState([]);
  const [LUPReportStandardDataset, setLUPReportStandardDataset] = useState([]);
  const [LUPReportRawDataset, setLUPReportRawDataset] = useState([]);
  const [LUPReportTempDataset, setLUPReportTempDataset] = useState([]);
  const [LUPReportDeletedDataset, setLUPReportDeletedDataset] = useState([]);
  const [fileData, setFileData] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const AppsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenLupOption(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const getLupReportMetadatasData = async () => {
    let data = await studyEDCLupReportingServices.getLupReportMetadatasData("active", studyId);
    setLUPReportMetadata(data?.data || []);
  };

  const getEDCLupDataLibrary = async () => {
    let data = await studyEDCLupReportingServices.getEDCLupDataLibrary("active", studyId, StudyMode);
    setLUPReportEDCWIDEDataset(data?.EDCWideList || []);
    setLUPReportEDCTRANSDataset(data?.EDCTransList || []);
    setLUPReportAnalysisDataset(data?.AnalysisList || []);
    setLUPReportStandardDataset(data?.StandardList || []);
    setLUPReportRawDataset(data?.RawList || []);
    setLUPReportTempDataset(data?.TempList || []);
  };

  const getEDCLupDeletedDataLibrary = async () => {
    try {
      const data = await studyEDCLupReportingServices.getEDCLupDataLibrary("deleted", studyId, StudyMode);
      setLUPReportDeletedDataset(data?.data || []);
    } catch (err) {
      console.error("Error fetching package data:", err);
    }
  };

  const syncEDCLupDataset = async (category) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to synchronize EDC ${category === "byRow" ? "Wide" : "Trans"} Dataset?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, synchronize it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Sync in Progress",
          html: "Please wait while dataset is syncing...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        let userData = {
          studyId: studyId,
          mode: StudyMode,
          category: category,
        };
        const data = await studyEDCLupReportingServices.syncEDCLupDataset(userData);
        Swal.close();
        if (data?.statusCode === 200) {
          await getEDCLupDataLibrary();
          Swal.fire({
            icon: "success",
            title: "Sync Completed",
            text: "EDC LUP dataset synced successfully",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      }
    });
  };

  const softDeleteRestoreEDCLupData = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} dataset!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.mode = StudyMode;
        userData.type = type;
        let data =
          await studyEDCLupReportingServices.softDeleteRestoreEDCLupData(
            userData
          );
        if (data?.statusCode === 200) {
          getEDCLupDataLibrary();
          getEDCLupDeletedDataLibrary();
        }
      }
    });
  };

  useEffect(() => {
    getLupReportMetadatasData();
    getEDCLupDataLibrary();
  }, [studyId, checkActiveDynamicTabData("edcLUPProgram")?.idObject?.runLupEditor]);

  return (
    <>
      <ListGroup.Item action
        className={`border-0 border-bottom ${openReporting && "bg-light"}`}
        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
        onClick={() => setOpenReporting(!openReporting)}
      >
        <div className="hstack justify-content-between w-100">
          <span>
            <i className={`fa-solid fa-${openReporting ? "folder-open" : "folder"} me-2`}></i>
            {!collapseSidebar && <span>LUP Reporting</span>}
          </span>
          <span>
            <i className={`fa-solid fa-angle-${openReporting ? "down" : "right"}`}></i>
          </span>
        </div>
      </ListGroup.Item>
      <Collapse in={openReporting === true}>
        <div>
          {StudyMode === "DBP Mode" && (
            <ListGroup.Item action
              className={`border-0 border-bottom ${checkActiveTab("edcLUPCategory") && "selectedMenu"}`}
              style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
              onClick={() => { handleAddNewTab("Category", "fa-solid fa-clipboard-list", "edcLUPCategory") }}
              title={"Category"}
            >
              <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
              {!collapseSidebar && <span>Category</span>}
            </ListGroup.Item>
          )}
          <ListGroup.Item action
            className={`border-0 border-bottom ${checkActiveTab("edcLUPReport") && "selectedMenu"}`}
            style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
            onClick={() => { handleAddNewTab("Report", "fa-solid fa-clipboard-list", "edcLUPReport") }}
            title={"Report"}
          >
            <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
            {!collapseSidebar && <span>Report</span>}
          </ListGroup.Item>
          {StudyMode === "DBP Mode" && (
            <>
              <ListGroup.Item action
                className={`border-0 border-bottom ${openLUPGenerateReport && "bg-light"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                onClick={() => { setOpenLUPGenerateReport(!openLUPGenerateReport); getLupReportMetadatasData() }}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className={`fa-solid fa-${openLUPGenerateReport ? "folder-open" : "folder"} me-2`}></i>
                    {!collapseSidebar && <span>Generate Report</span>}
                  </span>
                  <span>
                    <i className={`fa-solid fa-angle-${openLUPGenerateReport ? "down" : "right"}`}></i>
                  </span>
                </div>
              </ListGroup.Item>
              <Collapse in={openLUPGenerateReport === true}>
                <div>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openLUPProgram && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                    onClick={() => { LUPReportMetadata?.length > 0 && setOpenLUPProgram(!openLUPProgram) }}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-laptop-code me-2`}></i>
                        {!collapseSidebar && <span>Program</span>}
                      </span>
                      {LUPReportMetadata?.length > 0 &&
                        <span>
                          <i className={`fa-solid fa-angle-${openLUPProgram ? "down" : "right"}`}></i>
                        </span>
                      }
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openLUPProgram === true}>
                    <div>
                      {LUPReportMetadata?.map((item, index) => (
                        <ListGroup.Item action key={index}
                          className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPProgram")?.idObject?.reportId === item?.reportId && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                          onClick={() => { handleAddNewTab(`${item?.reportName}.glx`, "fa-regular fa-file-code", `edcLUPProgram_${item?.reportId}`, { ...item, ...{ studyLabel: studyLabel } }) }}
                          title={item?.reportName}
                        >
                          <i className="fa-regular fa-file-code clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>{item?.reportName}.glx</span>}
                        </ListGroup.Item>
                      ))}
                    </div>
                  </Collapse>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openLUPLogs && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                    onClick={() => { LUPReportMetadata?.length > 0 && setOpenLUPLogs(!openLUPLogs) }}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-laptop-code me-2`}></i>
                        {!collapseSidebar && <span>Logs</span>}
                      </span>
                      {LUPReportMetadata?.length > 0 &&
                        <span>
                          <i className={`fa-solid fa-angle-${openLUPLogs ? "down" : "right"}`}></i>
                        </span>
                      }
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openLUPLogs === true}>
                    <div>
                      {LUPReportMetadata?.map((item, index) => (
                        <ListGroup.Item action key={index}
                          className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPLogs")?.idObject?.reportId === item?.reportId && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                          onClick={() => { handleAddNewTab(`${item?.reportName}.glxlog`, "fa-regular fa-file-lines", `edcLUPLogs_${item?.reportId}`, { ...item, ...{ studyLabel: studyLabel } }) }}
                          title={item?.reportName}
                        >
                          <i className="fa-regular fa-file-lines clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>{item?.reportName}.glxlog</span>}
                        </ListGroup.Item>
                      ))}
                    </div>
                  </Collapse>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openLUPOutput && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                    onClick={() => { LUPReportMetadata?.length > 0 && setOpenLUPOutput(!openLUPOutput) }}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-laptop-code me-2`}></i>
                        {!collapseSidebar && <span>Output</span>}
                      </span>
                      {LUPReportMetadata?.length > 0 &&
                        <span>
                          <i className={`fa-solid fa-angle-${openLUPOutput ? "down" : "right"}`}></i>
                        </span>
                      }
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openLUPOutput === true}>
                    <div>
                      {LUPReportMetadata?.map((item, index) => (
                        <ListGroup.Item action key={index}
                          className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPOutputs")?.idObject?.reportId === item?.reportId && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                          onClick={() => { handleAddNewTab(`${item?.reportName}.glxoutput`, "fa-regular fa-file", `edcLUPOutputs_${item?.reportId}`, { ...item, ...{ studyLabel: studyLabel } }) }}
                          title={item?.reportName}
                        >
                          <i className="fa-regular fa-file clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>{item?.reportName}.glxoutput</span>}
                        </ListGroup.Item>
                      ))}
                    </div>
                  </Collapse>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openLUPReport && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                    onClick={() => { LUPReportMetadata?.length > 0 && setOpenLUPReport(!openLUPReport) }}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-${openLUPReport ? "folder-open" : "folder"} me-2`}></i>
                        {!collapseSidebar && <span>Report</span>}
                      </span>
                      {LUPReportMetadata?.length > 0 &&
                        <span>
                          <i className={`fa-solid fa-angle-${openLUPReport ? "down" : "right"}`}></i>
                        </span>
                      }
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openLUPReport === true}>
                    <div>
                      {LUPReportMetadata?.map((item, index) => (
                        <ListGroup.Item action key={index}
                          className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPGeneratedReport")?.idObject?.reportId === item?.reportId && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                          onClick={() => { handleAddNewTab(`${item?.reportName} [Report Files]`, "fa-solid fa-clipboard-list", `edcLUPGeneratedReport_${item?.reportId}`, item) }}
                          title={item?.reportName}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>{item?.reportName}</span>}
                        </ListGroup.Item>
                      ))}
                    </div>
                  </Collapse>
                  <ListGroup.Item action
                    className={`border-0 border-bottom ${openLUPDataLibrary && "bg-light"}`}
                    style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "45px"}` }}
                    onClick={() => { LUPReportMetadata?.length > 0 && setOpenLUPDataLibrary(!openLUPDataLibrary) }}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span>
                        <i className={`fa-solid fa-${openLUPDataLibrary ? "folder-open" : "folder"} me-2`}></i>
                        {!collapseSidebar && <span>Data Library</span>}
                      </span>
                      <div className="hstack gap-2">
                        <div onClick={(e) => { setOpenLupOption(openLupOption === "Data Library" ? "" : "Data Library"); e.stopPropagation() }}>
                          <CiMenuKebab />
                        </div>
                        {LUPReportMetadata?.length > 0 &&
                          <span>
                            <i className={`fa-solid fa-angle-${openLUPDataLibrary ? "down" : "right"}`}></i>
                          </span>
                        }
                        <Collapse in={openLupOption === "Data Library"}>
                          <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                            <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                              <ListGroup.Item action onClick={(e) => { toggles?.setToggle(); e.stopPropagation() }} className="text-success" title="Move Dataset" >
                                <i className={`fa-solid fa-upload me-1`} ></i>
                                Upload New Dataset
                              </ListGroup.Item>
                              <ListGroup.Item action onClick={(e) => { syncEDCLupDataset("byRow"); e.stopPropagation() }} className="text-success" title="Move Dataset" >
                                <i className={`fa-solid fa-rotate me-1`} ></i>
                                Sync EDC Wide
                              </ListGroup.Item>
                              <ListGroup.Item action onClick={(e) => { syncEDCLupDataset("byNameLabelView"); e.stopPropagation() }} className="text-success" title="Move Dataset" >
                                <i className={`fa-solid fa-rotate me-1`} ></i>
                                Sync EDC Trans
                              </ListGroup.Item>
                              <ListGroup.Item action onClick={(e) => { getEDCLupDeletedDataLibrary(); toggles?.setToggle5(); e.stopPropagation() }} className="text-danger" title="Delete Dataset" >
                                <i className={`fa-solid fa-trash-alt me-1`} ></i>
                                Deleted Dataset
                              </ListGroup.Item>
                            </ListGroup>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openLUPDataLibrary === true}>
                    <div>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPEDCWIDEData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportEDCWIDEDataset?.length > 0 && setOpenLUPEDCWIDEData(!openLUPEDCWIDEData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPEDCWIDEData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>EDCWide</span>}
                          </span>
                          {LUPReportEDCWIDEDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPEDCWIDEData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPEDCWIDEData === true}>
                        <div>
                          {LUPReportEDCWIDEDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [EDC Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `EDC_${item?.uniqueId}` ? "" : `EDC_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `EDC_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "EDC" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPEDCTRANSData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportEDCTRANSDataset?.length > 0 && setOpenLUPEDCTRANSData(!openLUPEDCTRANSData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPEDCTRANSData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>EDCTrans</span>}
                          </span>
                          {LUPReportEDCTRANSDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPEDCTRANSData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPEDCTRANSData === true}>
                        <div>
                          {LUPReportEDCTRANSDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [EDC Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `EDC_${item?.uniqueId}` ? "" : `EDC_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `EDC_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "EDC" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPAnalysisData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportAnalysisDataset?.length > 0 && setOpenLUPAnalysisData(!openLUPAnalysisData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPAnalysisData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>Analysis</span>}
                          </span>
                          {LUPReportAnalysisDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPAnalysisData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPAnalysisData === true}>
                        <div>
                          {LUPReportAnalysisDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [Analysis Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `Analysis_${item?.uniqueId}` ? "" : `Analysis_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `Analysis_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle1(); e.stopPropagation() }} className="text-primary" title="Rename Dataset" >
                                          <i className={`fa-solid fa-pen-to-square me-1`} ></i>
                                          Rename Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle2(); e.stopPropagation() }} className="text-primary" title="Move Dataset" >
                                          <i className={`fa-solid fa-scissors me-1`} ></i>
                                          Move Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle3(); e.stopPropagation() }} className="text-primary" title="Duplicate Dataset" >
                                          <i className={`fa-solid fa-clone me-1`} ></i>
                                          Duplicate Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { softDeleteRestoreEDCLupData(item?._id, "delete"); toggles?.setToggle4(); e.stopPropagation() }} className="text-danger" title="Delete Dataset" >
                                          <i className={`fa-solid fa-trash-alt me-1`} ></i>
                                          Delete Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "Analysis" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPStandardData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportStandardDataset?.length > 0 && setOpenLUPStandardData(!openLUPStandardData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPStandardData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>Standard</span>}
                          </span>
                          {LUPReportStandardDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPStandardData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPStandardData === true}>
                        <div>
                          {LUPReportStandardDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [Standard Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `Standard_${item?.uniqueId}` ? "" : `Standard_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `Standard_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle1(); e.stopPropagation() }} className="text-primary" title="Rename Dataset" >
                                          <i className={`fa-solid fa-pen-to-square me-1`} ></i>
                                          Rename Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle2(); e.stopPropagation() }} className="text-primary" title="Move Dataset" >
                                          <i className={`fa-solid fa-scissors me-1`} ></i>
                                          Move Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle3(); e.stopPropagation() }} className="text-primary" title="Duplicate Dataset" >
                                          <i className={`fa-solid fa-clone me-1`} ></i>
                                          Duplicate Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { softDeleteRestoreEDCLupData(item?._id, "delete"); toggles?.setToggle4(); e.stopPropagation() }} className="text-danger" title="Delete Dataset" >
                                          <i className={`fa-solid fa-trash-alt me-1`} ></i>
                                          Delete Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "Standard" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPRawData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportRawDataset?.length > 0 && setOpenLUPRawData(!openLUPRawData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPRawData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>Raw</span>}
                          </span>
                          {LUPReportRawDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPRawData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPRawData === true}>
                        <div>
                          {LUPReportRawDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [Raw Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `Raw_${item?.uniqueId}` ? "" : `Raw_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `Raw_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle1(); e.stopPropagation() }} className="text-primary" title="Rename Dataset" >
                                          <i className={`fa-solid fa-pen-to-square me-1`} ></i>
                                          Rename Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle2(); e.stopPropagation() }} className="text-primary" title="Move Dataset" >
                                          <i className={`fa-solid fa-scissors me-1`} ></i>
                                          Move Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle3(); e.stopPropagation() }} className="text-primary" title="Duplicate Dataset" >
                                          <i className={`fa-solid fa-clone me-1`} ></i>
                                          Duplicate Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { softDeleteRestoreEDCLupData(item?._id, "delete"); toggles?.setToggle4(); e.stopPropagation() }} className="text-danger" title="Delete Dataset" >
                                          <i className={`fa-solid fa-trash-alt me-1`} ></i>
                                          Delete Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "Raw" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                      <ListGroup.Item action
                        className={`border-0 border-bottom ${openLUPTempData && "bg-light"}`}
                        style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "55px"}` }}
                        onClick={() => { LUPReportTempDataset?.length > 0 && setOpenLUPTempData(!openLUPTempData) }}
                      >
                        <div className="hstack justify-content-between w-100">
                          <span>
                            <i className={`fa-solid fa-${openLUPTempData ? "folder-open" : "folder"} me-2`}></i>
                            {!collapseSidebar && <span>Temp</span>}
                          </span>
                          {LUPReportTempDataset?.length > 0 &&
                            <span>
                              <i className={`fa-solid fa-angle-${openLUPTempData ? "down" : "right"}`}></i>
                            </span>
                          }
                        </div>
                      </ListGroup.Item>
                      <Collapse in={openLUPTempData === true}>
                        <div>
                          {LUPReportTempDataset?.map((item, index) => (
                            <ListGroup.Item action key={index}
                              className={`border-0 border-bottom ${checkActiveDynamicTabData("edcLUPDataLibrary")?.idObject?.uniqueId === item?.uniqueId && "selectedMenu"}`}
                              style={{ padding: `3px 8px 7px ${collapseSidebar ? "15px" : "65px"}` }}
                              onClick={() => { handleAddNewTab(`${item?.name}.glxdat [Temp Library]`, "fa-solid fa-clipboard-list", `edcLUPDataLibrary_${item?.uniqueId}`, item) }}
                              title={`${item?.label}.glxdat`}
                            >
                              <div className="hstack justify-content-between w-100">
                                <span>
                                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                                  {!collapseSidebar && <span>{item?.name}.glxdat</span>}
                                </span>
                                <div className="hstack gap-2">
                                  <div onClick={(e) => { setOpenLupOption(openLupOption === `Temp_${item?.uniqueId}` ? "" : `Temp_${item?.uniqueId}`); e.stopPropagation() }}>
                                    <CiMenuKebab />
                                  </div>
                                  <Collapse in={openLupOption === `Temp_${item?.uniqueId}`}>
                                    <div className="position-absolute end-0 z-1" style={{ top: 36, width: "max-content" }}>
                                      <ListGroup className="br3" style={{ fontSize: 12 }} ref={AppsRef}>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle1(); e.stopPropagation() }} className="text-primary" title="Rename Dataset" >
                                          <i className={`fa-solid fa-pen-to-square me-1`} ></i>
                                          Rename Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle2(); e.stopPropagation() }} className="text-primary" title="Move Dataset" >
                                          <i className={`fa-solid fa-scissors me-1`} ></i>
                                          Move Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData(item); toggles?.setToggle3(); e.stopPropagation() }} className="text-primary" title="Duplicate Dataset" >
                                          <i className={`fa-solid fa-clone me-1`} ></i>
                                          Duplicate Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { softDeleteRestoreEDCLupData(item?._id, "delete"); toggles?.setToggle4(); e.stopPropagation() }} className="text-danger" title="Delete Dataset" >
                                          <i className={`fa-solid fa-trash-alt me-1`} ></i>
                                          Delete Dataset
                                        </ListGroup.Item>
                                        <ListGroup.Item action onClick={(e) => { setFileData({ ...item, ...{ libraryName: "Temp" } }); toggles?.setToggle6(); e.stopPropagation() }} className="text-secondary" title="Dataset Properties" >
                                          <i className={`fa-solid fa-info me-1`} ></i>
                                          Dataset Properties
                                        </ListGroup.Item>
                                      </ListGroup>
                                    </div>
                                  </Collapse>
                                </div>
                              </div>
                            </ListGroup.Item>
                          ))}
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </div>
              </Collapse>
            </>
          )}
        </div>
      </Collapse>
      <UploadFileDataLibrary
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title="Upload New Dataset"
        getEDCLupDataLibrary={getEDCLupDataLibrary}
      />
      <UpdateFileDataLibrary
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title="Rename Dataset"
        updateType="update"
        fileData={fileData}
        getEDCLupDataLibrary={getEDCLupDataLibrary}
      />
      <UpdateFileDataLibrary
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        Title="Move Dataset"
        updateType="move"
        fileData={fileData}
        getEDCLupDataLibrary={getEDCLupDataLibrary}
      />
      <DuplicateFileDataLibrary
        Show={!toggles?.toggle3}
        Hide={toggles?.setToggle3}
        Title="Duplicate Dataset"
        fileData={fileData}
        getEDCLupDataLibrary={getEDCLupDataLibrary}
      />
      <DeletedLupDataset
        Show={!toggles?.toggle5}
        Hide={toggles?.setToggle5}
        Title="Deleted Dataset"
        LUPReportDeletedDataset={LUPReportDeletedDataset}
        softDeleteRestoreEDCLupData={softDeleteRestoreEDCLupData}
      />
      <FileDataProperties
        Show={!toggles?.toggle6}
        Hide={toggles?.setToggle6}
        Title="File Properties"
        fileData={fileData}
      />
    </>
  );
};

export default LupReportingStudySidebar;
